document.addEventListener("DOMContentLoaded", function () {
  const sortSelect = document.querySelector('select[name="sort_option"]');

  sortSelect.addEventListener("change", function () {
    const url = new URL(window.location.href);

    const selectedValue = sortSelect.value;

    if (selectedValue) {
      url.searchParams.set("sort_by", selectedValue);
    } else {
      url.searchParams.delete("sort_by");
    }

    window.location.href = url.toString();
  });
});
